import { order } from '../api/order'

export const state = {
  logindata: {
    username: '',
    password: '',
    url: ''
  }
}

export const getters = {
  logindata: (state) => {
    return state.logindata
  }
}

export const mutations = {
  SET_LOGINDATA: (state, logindata) => {
    state.logindata = logindata
  }
}

export const actions = {
  async Order ({ dispatch, commit, state }, userdata) {
    commit('form/RESET_ERRORS', null, { root: true })

    await order(userdata)
      .then(({ data }) => {
        commit('SET_LOGINDATA', data)
      })
      .catch(error => {
        commit('form/SET_ERRORS', error.response.data.errors, { root: true })
      })
    return true
  }
}
